export const INITIAL_APPOINTMENTS = [];

export const STAFF = [
  { id: 'staff-mf', initials: 'MF', name: 'Mike Ford',              title: 'Master Detailer',    status: 'available' },
  { id: 'staff-ca', initials: 'CA', name: 'Chung-Anson',            title: 'Precision Detailer', status: 'available' },
  { id: 'staff-et', initials: 'ET', name: 'Edward Tsai',            title: 'Surface Specialist', status: 'available' },
  { id: 'staff-tm', initials: 'TM', name: 'Tony Marianetti',        title: 'Paint Correction',   status: 'available' },
  { id: 'staff-nk', initials: 'NK', name: 'Nicholas Kalakonis',     title: 'Junior Detailer',    status: 'available' },
  { id: 'staff-kc', initials: 'KC', name: 'Kero De La Cruz',        title: 'Junior Detailer',    status: 'available' },
  { id: 'staff-ab', initials: 'AB', name: 'Alex Blais',             title: 'Detailer',           status: 'available' },
  { id: 'staff-aa', initials: 'AA', name: 'Adebayo Abolurin',       title: 'Detailer',           status: 'available' },
  { id: 'staff-ri', initials: 'RI', name: 'Risto',                  title: 'Detailer',           status: 'available' },
];

export const RANKINGS = [
  { name: 'Edward Tsai',        pts: 148, delta: '+4.2%', positive: true },
  { name: 'Nicholas Kalakonis', pts: 132, delta: '+1.8%', positive: true },
  { name: 'Kero De La Cruz',    pts: 128, delta: '-0.6%', positive: false },
  { name: 'Tony Marianetti',    pts: 115, delta: '+2.3%', positive: true },
  { name: 'Mike Ford',          pts: 108, delta: '+1.1%', positive: true },
  { name: 'Chung-Anson',        pts: 97,  delta: '+0.5%', positive: true },
  { name: 'Alex Blais',         pts: 0,   delta: '+0.0%', positive: true },
  { name: 'Adebayo Abolurin',   pts: 0,   delta: '+0.0%', positive: true },
  { name: 'Risto',              pts: 0,   delta: '+0.0%', positive: true },
];

export const CHECKLIST_STEPS = [
  'Started',
  'Photos',
  'Finished',
  'Upsells',
  'Payment',
  'Posted',
];

export const BAYS = ['01', '02', '03', '04', '05', '06'];
